const importAll = (requireContext) => {
  const logos = {};
  requireContext.keys().forEach((key) => {
    const fileName = key.replace("./", "").replace(".svg", "");
    logos[fileName] = requireContext(key);
  });
  return logos;
};

const logos = importAll(require.context("../imgs/cars_logo", false, /\.svg$/));

export default logos;
